import { EasmBulkChangeInvestigationPropertyDataProvider } from './EasmBulkChangeInvestigationPropertyDataProvider';
import { translateFn } from '../../../utils/translator.helper';
import { FindingClassType } from '../../types';

export class EasmBulkChangeInvestigationStatusDataProvider extends EasmBulkChangeInvestigationPropertyDataProvider {
  public getTitle(): string {
    return translateFn('Change status?');
  }

  public getDescription(findingsClassType: FindingClassType, preSelectedValueLabel: string | null): string {
    if (FindingClassType.ASSET === findingsClassType) {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The status of the selected assets will change to <b>{investigationStatus}</b>.',
          { investigationStatus: preSelectedValueLabel }
        )
        : translateFn('Select the status for this asset.');
    } else {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The status of the selected artifacts will change to <b>{investigationStatus}</b>.',
          { investigationStatus: preSelectedValueLabel }
        )
        : translateFn('Select the status for this artifact.');
    }
  }

  public getOptionsLabel(): string {
    return translateFn('Investigation status');
  }

  public getOptionsPlaceholder(): string {
    return translateFn('Select investigation status');
  }

  public getRequiredOptionErrorMessage(): string {
    return translateFn('Please select an investigation status.');
  }

  public getApplyToArtifactsOptionLabel(): string {
    return translateFn('Apply note and status also to asset artifacts');
  }

  public getSuccessToastMessage(response: any): string {
    return translateFn('Status changed successfully.');
  }

  public getFailureToastMessage(error: any, value: any): string {
    return translateFn('Failed to change the status.');
  }

  protected getApiInvestigationProperty(): string {
    return 'status';
  }
}
